// ! Controls flow between pages

import React from 'react';

import {
  AvailableFlows,
  FlowV2Connectors,
  FlowSources,
  FlowTargets,
  UploadFile,
  ConnectParams,
  SyncSchedule,
  CopyEntity,
  Loading,
  FieldMapSelector,
  FieldMapSelectorV2,
  FieldMapTransferList,
  EntityConfig
} from './pages';

const Router = (props) => {
  const { page } = props;
  switch (page) {
    case 'AvailableFlows':
      return <AvailableFlows />;
    case 'FlowV2Connectors':
      return <FlowV2Connectors />;
    case 'FlowSources':
      return <FlowSources />;
    case 'FlowTargets':
      return <FlowTargets />;
    case 'UploadFile':
      return <UploadFile />;
    case 'ConnectParams':
      return <ConnectParams />;
    case 'SyncSchedule':
      return <SyncSchedule />;
    case 'CopyEntity':
      return <CopyEntity />;
    case 'Loading':
      return <Loading />;
    case 'FieldMapSelector':
      return <FieldMapSelector />;
    case 'FieldMapSelectorV2':
      return <FieldMapSelectorV2 />;
    case 'FieldMapTransferList':
      return <FieldMapTransferList />;
    case 'EntityConfig':
      return <EntityConfig />;
    default:
      return <Loading />;
  }
};

export default Router;
